import { IError } from '@checkout/errors';
import { ILanguageChangeSuccessPayload } from '@checkout/payloadTypes';
import { RootState } from '@checkout/state';
import { AxiosResponse } from 'axios';
import { Epic } from 'redux-observable';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/mergeMap';
import { fromPromise as fromPromise$ } from 'rxjs/observable/fromPromise';
import { of as of$ } from 'rxjs/observable/of';
import { LanguageChangeRequestAction, RootAction } from '../actions/actionTypes.d';
import ActionTypes from './../actions/actionTypes';
import { languageChangeSuccess, languageFallback } from './../reducers/checkout';
import { rest } from './../utils/apiUtils';
import { logger } from './../utils/logger';

export const changeLanguageEpic: Epic<RootAction, RootAction, RootState> =
  (action$, state$) => action$
    .ofType(ActionTypes.LOCALE_TRANSLATIONS_FETCH_REQUEST)
    .mergeMap((action: LanguageChangeRequestAction) => {
      return fromPromise$(rest.httpPut(`/languages/${action.payload.language}`))
        .flatMap((response: AxiosResponse<ILanguageChangeSuccessPayload>) => {
          return of$(languageChangeSuccess(response.data));
        })
        .catch((error: IError) => {
          logger(error);
          return of$(languageFallback(action.payload.language));
        });
    });



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/epics/languages.ts